/**
 * User-settings API client. All calls are auth-required.
 */
import { API } from "@/lib/api";
import { getAccessToken, supabase } from "@/lib/supabaseClient";

async function authHeader() {
    const tok = await getAccessToken();
    return tok ? { Authorization: `Bearer ${tok}` } : {};
}

async function throwWithBody(r, action) {
    let detail;
    const raw = await r.text(); try { detail = JSON.parse(raw); } catch { detail = { message: raw }; }
    const err = new Error(`${action} failed (${r.status})`);
    err.status = r.status;
    err.detail = detail;
    throw err;
}

export async function getSettings() {
    const r = await fetch(`${API}/settings`, { headers: { ...(await authHeader()) } });
    if (!r.ok) await throwWithBody(r, "getSettings");
    return r.json();
}

export async function patchSettings(patch) {
    const r = await fetch(`${API}/settings`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", ...(await authHeader()) },
        body: JSON.stringify(patch),
    });
    if (!r.ok) await throwWithBody(r, "patchSettings");
    return r.json();
}

export async function getPromptPreview() {
    const r = await fetch(`${API}/settings/prompt-preview`, { headers: { ...(await authHeader()) } });
    if (!r.ok) await throwWithBody(r, "getPromptPreview");
    return r.json();
}

/** Supabase-native password update. Auto-invalidates other sessions per project setting. */
export async function updatePassword(newPassword) {
    const { data, error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) throw error;
    return data;
}
